import MuiTabs from "@mui/material/Tabs";
import MuiTab from "@mui/material/Tab";
import { Box } from "./MuiGenerals";
import { useTranslation } from "src/hooks";
import PendingCount from "./PendingCount";

type VersionTabsArr = { walletMajorVersion: number; walletCounts: number };

type Props = {
  walletMajorVersion: number;
  tabsArr: VersionTabsArr[];
  setWalletMajorVersion: (walletMajorVersion: number) => void;
};

const VersionTabs = (props: Props) => {
  const { walletMajorVersion, tabsArr, setWalletMajorVersion } = props;
  const { t } = useTranslation("common");

  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider", marginBottom: "1rem" }}>
      <MuiTabs value={walletMajorVersion} onChange={() => {}} aria-label="tabs">
        {tabsArr.map(({ walletMajorVersion, walletCounts }, i) => (
          <MuiTab
            value={walletMajorVersion}
            key={i}
            label={
              <Box
                sx={{ display: "flex", gap: "0.5rem", alignItems: "center" }}>
                {`${t(`wallet_major_version`)} ${walletMajorVersion}`}
                <PendingCount count={walletCounts} showOriginalCount />
              </Box>
            }
            onClick={() => {
              setWalletMajorVersion(walletMajorVersion);
            }}
          />
        ))}
      </MuiTabs>
    </Box>
  );
};

export default VersionTabs;
export { type VersionTabsArr };
